/* eslint-disable linebreak-style */
import { CSSTransition } from "react-transition-group";
import { useTranslation } from "react-i18next";

import React from "react";
import BigBackgroundText from "../TextComponents/BigBackgroundText";
import EvrRatioHeightAndWeight from "../../navigation/MattressBuilder/common/EvrRatioHeightAndWeight";
import evrbedSingle1 from "../../assets/images/mattress/evrbed-single-1.png";
import evrbedSingle2 from "../../assets/images/mattress/evrbed-single-2.png";
import evrbedSingle3 from "../../assets/images/mattress/evrbed-single-3.png";
import evrbedSingle4 from "../../assets/images/mattress/evrbed-single-4.png";
import evrbedSingle5 from "../../assets/images/mattress/evrbed-single-5.png";
import evrbedSingle6 from "../../assets/images/mattress/evrbed-single-6.png";
import evrbedPartner1 from "../../assets/images/mattress/evrbed-partner-1.png";
import evrbedPartner2 from "../../assets/images/mattress/evrbed-partner-2.png";
import evrbedPartner3 from "../../assets/images/mattress/evrbed-partner-3.png";
import evrbedPartner4 from "../../assets/images/mattress/evrbed-partner-4.png";
import evrbedPartner5 from "../../assets/images/mattress/evrbed-partner-5.png";
import evrbedPartner6 from "../../assets/images/mattress/evrbed-partner-6.png";


import useMediaQuery from "@mui/material/useMediaQuery";
import {useSelector} from "react-redux";
import {isSingleSleeperSelector} from "../../redux/slices/mattressConfiguration";

import {
  currentStepDoubleSleeperMattressBuilderSelector,
  currentStepGeneralSelector,
  currentStepSingleSleeperMattressBuilderSelector
} from "../../redux/slices/customNavigation";

const MattressBackground = ({ children, showCondition }) => {
  const { t } = useTranslation();
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const currentStepGeneral = useSelector(currentStepGeneralSelector);
  const currentStepSingleSelector = useSelector(currentStepSingleSleeperMattressBuilderSelector);
  const currentStepPartnerSelector = useSelector(currentStepDoubleSleeperMattressBuilderSelector);

  function getMattressPhoto() {
    console.log("currentStepGeneral: " + currentStepGeneral);
    console.log("isSingleSleeper: " + isSingleSleeper);

    switch(currentStepGeneral) {
    case 0:
      if (isSingleSleeper) {
        return evrbedSingle1;
      } else {
        return evrbedPartner1;
      }

    case 1:
      if (isSingleSleeper) {
        switch (currentStepSingleSelector) {
        case 1:
          return evrbedSingle3;
        case 2:
          return evrbedSingle4;
        case 3:
          return evrbedSingle5;
        case 4:
          return evrbedSingle6;
        default:
          return evrbedSingle2;
        }
      } else {
        switch (currentStepPartnerSelector) {
        case 1:
          return evrbedPartner3;
        case 2:
          return evrbedPartner4;
        case 3:
          return evrbedPartner5;
        case 4:
          return evrbedPartner6;
        default:
          return evrbedPartner2;
        }
      }

    default:
      return evrbedSingle1;
    }
  }

  return (
    <>
      <BigBackgroundText
        className="text-center"
        styles={{ zIndex: 100, marginTop: isExtraLargeScreen ? "" : "25vh" }}
        text={t("evrbed")}
      ></BigBackgroundText>
      <img
        className="mx-auto"
        style={{
          marginTop: isExtraLargeScreen ? "-5vh" : "-5vh",
          zIndex: 99,
          position: "relative",
          width: isExtraLargeScreen ? "50vw" : "35vw",
        }}
        src={getMattressPhoto()}
      ></img>
      <CSSTransition
        in={showCondition}
        timeout={500}
        classNames={{
          enterActive: "animate__bounceIn",
          exitActive: "animate__bounceOut",
        }}
      >
        <>{children}</>
      </CSSTransition>
    </>
  );
};

export default MattressBackground;
